<template>
  <div>
    <BaseFrame
      clear-text=""
      cancel-text="取消"
      submit-text="提交"
      :submit-loading="submitLoading"
      @cancel="clear"
      @submit="addUnqualifiedRecords">
      <div slot="content">
        <lk-card title="不合格单信息">
          <lk-form :label-width="120" ref="form" :model="unqualifiedModel" :rules="unqualifiedRules">
            <lk-row :gutter="16">
              <lk-col span="10">
                <lk-form-item label="提报时间:" prop="scrapTime">
                  <timeStampDatePicker class="item" v-model="unqualifiedModel.scrapTime" :options="options"></timeStampDatePicker>
                </lk-form-item>
              </lk-col>
              <lk-col offset="2" span="10">
                <lk-form-item label="不合格商品:">
                  <lk-button type="primary" @click="handleAddGoods">新增</lk-button>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="22">
                <lk-form-item>
                  <div class="requireBreakAdd">
                    <lk-table border :columns="columns" :data="tableData"></lk-table>
                  </div>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </lk-form>
        </lk-card>
      </div>
    </BaseFrame>
    <lk-modal
      v-model="showModal"
      title="不合格商品"
      width="900">
      <div class="queryContainer">
        <div class="queryItem">
          <goodsSearchItem labelString="关键词" v-model="modalQueryParams.nameMix"></goodsSearchItem>
        </div>
        <div class="queryItem">
          <label>有效天数小于等于:</label>
          <DtpInputNumber
            v-model.trim="modalQueryParams.beforeExpireDays"
            placeholder="请输入" class="item" style="width:130px;" clearable
            :min="0"
            :max="1000000000"
            :precision="0">
          </DtpInputNumber>
        </div>
        <div class="queryItem">
          <lk-button type="primary" class="mr8" @click="handleModalSearch">查询</lk-button>
          <lk-button @click="clearModalQuery" class="mr8">重置</lk-button>
        </div>
      </div>
      <div style="position: relative;">
        <loading v-show="modalLoading"></loading>
        <lk-table
          border
          height="400"
          :columns="modalColumns"
          :data="modalTableData"
          @on-select="handleTempSelect"
          @on-select-cancel="handleTempCancel"
          @on-select-all="handleSelectAll"
          @on-select-all-cancel="handleSelectAllCancel">
        </lk-table>
      </div>
      <div style="margin-top: 14px; text-align: right;">
        <lk-page
          :total="goodsPage.count"
          :page-size="goodsPage.size"
          :current="goodsPage.page"
          size="small"
          show-sizer
          show-elevator
          @on-change='handleGoodsPage'
          @on-page-size-change='handleGoodsSize'>
        </lk-page>
      </div>
      <div slot="footer">
        <div class="queryItem">
          <span style="padding-right: 16px;">已选:{{this.tempGoods.length + this.tableData.length}}项</span>
          <lk-button @click="clearModal">取消</lk-button>
          <lk-button type="primary" class="mr" @click="pushData">确定</lk-button>
        </div>
      </div>
    </lk-modal>
  </div>
</template>
<script>
import BaseFrame from '../../components/frame/BaseFrame';
import inventory from '../../services/inventory';
import utils from '../../libs/utils';
import loading from '../../components/LoadingSpan.vue';
import DtpInputNumber from '../../components/DtpInputNumber';

export default {
  name: 'unqualifiedAdd',
  components: {
    BaseFrame,
    loading,
    DtpInputNumber,
  },
  data() {
    const self = this;
    return {
      showModal: false,
      inventoryIds: '',
      modalLoading: false,
      submitLoading: false,
      tempGoods: [],
      queryParams: {},
      inventoryIdMap: {},
      unqualifiedModel: {
        scrapTime: new Date().getTime(),
      },
      unqualifiedRules: {
        scrapTime: [
          { required: true, message: '请选择提报时间', type: 'number' },
        ],
      },
      modalQueryParams: {
        nameMix: null,
        beforeExpireDays: null,
      },
      modalParams: {},
      statusMap: new Map([
        [1, '启用'],
        [2, '禁用'],
      ]),
      unqualifiedTypes: [{
        id: 1,
        name: '药品过期',
      }, {
        id: 2,
        name: '药监抽检',
      }, {
        id: 3,
        name: '药品损坏',
      }, {
        id: 5,
        name: '效期滞销',
      }
      ],
      options: {
        disabledDate(date) {
          return date && date.valueOf() > Date.now();
        },
      },
      columns: [
        {
          title: '商品编码',
          key: 'drugSerialCode',
          minWidth: 110,
          render: (h, params) => {
            if (!params.row.drugSerialCode) {
              return h('lk-input');
            }
            return h('span', params.row.drugSerialCode);
          },
        },
        {
          title: '商品名称',
          key: 'goodsName',
          minWidth: 110,
        },
        {
          title: '通用名称',
          key: 'approvedDrugNames',
          minWidth: 110,
          render: (h, params) => {
            if (!params.row.approvedDrugNames) {
              return h('lk-input');
            }
            return h('span', params.row.approvedDrugNames);
          },
        },
        {
          title: '规格',
          key: 'specifications',
          minWidth: 110,
        },
        {
          title: '剂型',
          key: 'dosageForm',
          minWidth: 110,
        },
        {
          title: '单位',
          key: 'drugMiniPackageUnit',
          minWidth: 110,
        },
        {
          title: '仓库',
          key: 'warehouseName',
          minWidth: 110,
        },
        {
          title: '货位',
          key: 'locationCode',
          minWidth: 150,
        },
        {
          title: '数量',
          key: 'couldSaleNum',
          minWidth: 60,
        },
        {
          title: '批次',
          key: 'goodsBatchSeq',
          minWidth: 150,
        },
        {
          title: '批号',
          key: 'goodsBatchNumber',
          minWidth: 110,
        },
        {
          title: '有效日期',
          key: 'goodsExpiryDate',
          minWidth: 110,
        },
        {
          title: '不合格数量',
          key: 'unqualifiedCount',
          fixed: 'right',
          minWidth: 130,
          render: (h, params) => h(DtpInputNumber, {
            props: {
              value: params.row.unqualifiedCount,
              min: 0,
              max: params.row.couldSaleNum,
              precision: 3,
              ifNeedCheckAllNumber: true,
              frontDecimal: 7,
              activeChange: false,
              maxlength: 11,
            },
            on: {
              'on-change': (value) => {
                const index = params.row._index;
                this.tableData[index].unqualifiedCount = value;
              },
            },
          }),
        },
        {
          title: '不合格原因',
          key: 'applyReason',
          fixed: 'right',
          minWidth: 130,
          render: (h, params) => {
            const optionArr = self.unqualifiedTypes.map(item => h('lk-option', {
              props: {
                value: item.name,
              },
            }, item.name));
            return h('lk-select',
              {
                props: {
                  value: params.row.applyReason,
                  transfer: true,
                },
                on: {
                  'on-change': (value) => {
                    this.tableData[params.row._index].applyReason = value;
                  },
                },
              },
              optionArr);
          },
        },
        {
          title: '操作',
          key: 'addBtn',
          minWidth: 100,
          fixed: 'right',
          render: (h, params) => h('div', [
            h('lk-button', {
              props: {
                type: 'text',
              },
              on: {
                click: () => {
                  const index = params.row._index;
                  delete this.inventoryIdMap[params.row.id];
                  this.tableData.splice(index, 1);
                },
              },
            }, '删除'),
          ]),
        },
      ],
      tableData: [],
      modalTableData: [],
      modalColumns: [
        {
          title: '选择',
          key: 'id',
          type: 'selection',
          width: 60,
        },
        {
          title: '商品编码',
          key: 'drugSerialCode',
          minWidth: 110,
        },
        {
          title: '商品名称',
          key: 'goodsName',
          minWidth: 110,
        },
        {
          title: '通用名称',
          key: 'approvedDrugNames',
          minWidth: 110,
        },
        {
          title: '规格',
          key: 'specifications',
          minWidth: 110,
        },
        {
          title: '剂型',
          key: 'dosageForm',
          minWidth: 110,
        },
        {
          title: '生产厂家',
          key: 'manufacturer',
          minWidth: 110,
        },
        {
          title: '商品状态',
          key: 'goodsStoreStatusStr',
          minWidth: 110,
        },
        {
          title: '单位',
          key: 'drugMiniPackageUnit',
          minWidth: 110,
        },
        {
          title: '仓库',
          key: 'warehouseName',
          minWidth: 110,
        },
        {
          title: '货位',
          key: 'locationCode',
          minWidth: 110,
        },
        {
          title: '数量',
          key: 'couldSaleNum',
          minWidth: 110,
        },
        {
          title: '批次',
          key: 'goodsBatchSeq',
          minWidth: 110,
        },
        {
          title: '批号',
          key: 'goodsBatchNumber',
          minWidth: 110,
        },
        {
          title: '入库日期',
          key: 'createTime',
          minWidth: 120,
        },
        {
          title: '生产日期',
          key: 'goodsProductionDate',
          minWidth: 120,
        },
        {
          title: '有效日期',
          key: 'goodsExpiryDate',
          minWidth: 120,
        },
        {
          title: '有效天数',
          key: 'beforeExpireDays',
          minWidth: 120,
        },
        {
          title: '预警天数',
          key: 'periodAlertDays',
          minWidth: 120,
        },
      ],
      page: 1,
      size: 10,
      count: 0,
      goodsPage: {
        page: 1,
        size: 10,
        count: 0,
      },
    };
  },
  computed: {
    selectedIds() {
      const result = [];
      this.tableData.forEach((item) => {
        result.push(item.id);
      });
      return result;
    },
    selectedTempGoodsIds() {
      const result = [];
      this.tempGoods.forEach((item) => {
        result.push(item.id);
      });
      return result;
    },
  },
  methods: {
    handleAddGoods() {
      this.showModal = true;
      this.clearModalQuery();
      this.modalSelection = [];
      this.handleModalSearch();
    },
    pushData() {
      if (this.tempGoods.length < 0 && this.tableData.length < 0) {
        this.$Message.error('请选择不合格商品');
        return;
      }
      this.tempGoods.forEach((item) => {
        item.unqualifiedCount = item.unqualifiedCount || 0;
        this.tableData.push(item);
      });
      this.tempGoods = [];
      this.hideModal();
    },
    getData() {
      const inventoryIds = this.inventoryIds.split(',');
      this.queryParams.page = this.page;
      this.queryParams.size = inventoryIds.length || this.size;
      this.queryParams.inventoryIds = inventoryIds;
      inventory.expireList(this.queryParams).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item.inventoryExpire, result);
            result.createTime = utils.exchangeTime(result.createTime);
            result.goodsProductionDate = utils.exchangeTime(result.goodsProductionDate);
            result.goodsExpiryDate = utils.exchangeTime(result.goodsExpiryDate);
            result.unqualifiedCount = result.unqualifiedCount || 0;
            result.applyReason = result.applyReason || '';
            result.goodsStockNum = result.goodsStockAmount || 0;
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getInventoryData() {
      const params = {};
      params.page = this.goodsPage.page;
      params.size = this.goodsPage.size;
      if (this.modalParams.nameMix) {
        params.nameMix = this.modalParams.nameMix;
      }

      if (this.modalParams.beforeExpireDays) {
        params.beforeExpireDays = this.modalParams.beforeExpireDays;
        if (!utils.forbiddenDate.signlessIntegerValidator(params.beforeExpireDays)) {
          this.$Message.error('请输入正确的数字');
          return;
        }
      }
      this.$store.commit('setDisableLoading', true);
      this.modalLoading = true;
      inventory.expireSearch(params).then((res) => {
        if (res.data.status === 200) {
          this.modalTableData = [];
          const { count, list } = res.data.data;
          this.goodsPage.count = count;
          list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            result.beforeExpireDays = Math.ceil((new Date(result.goodsExpiryDate) - new Date()) / (24 * 3600 * 1000));
            result.createTime = utils.exchangeTime(result.createTime);
            result.goodsProductionDate = utils.exchangeTime(result.goodsProductionDate);
            result.goodsExpiryDate = utils.exchangeTime(result.goodsExpiryDate);
            result.goodsStoreStatusStr = this.statusMap.get(result.goodsStoreStatus);
            result.unqualifiedCount = result.unqualifiedCount || 0;
            result.applyReason = result.applyReason || '';
            result._checked = this.selectedIds.includes(result.id) || this.selectedTempGoodsIds.includes(result.id);
            result._disabled = this.selectedIds.includes(result.id);
            this.modalTableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
        this.modalLoading = false;
      }).catch((err) => {
        this.modalLoading = false;
        utils.handleError(err);
      });
    },
    addUnqualifiedRecords() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let errorMsg = '';
          const params = [];
          if (this.tableData.length === 0) {
            this.$Message.error('请添加不合格记录');
            return;
          }
          for (let i = 0, len = this.tableData.length; i < len; i++) {
            const item = this.tableData[i];
            if (item.unqualifiedCount === 0) {
              errorMsg = '不合格数量不能为0';
              break;
            }
            if (item.unqualifiedCount > item.goodsStockNum) {
              errorMsg = '不合格数量不能超过库存数量';
              break;
            }
            if (!item.applyReason) {
              errorMsg = '请选择不合格原因';
              break;
            }
            const param = {
              inventoryId: item.id,
              unqualifiedCount: item.unqualifiedCount,
              applyReason: item.applyReason,
              createTime: this.unqualifiedModel.scrapTime,
              goodsStoreId: item.goodsStoreId || '',
            };
            params.push(param);
          }
          if (errorMsg) {
            this.$Message.error(errorMsg);
            return;
          }

          this.submitLoading = true;
          inventory.addUnqualifiedRecords({ unqualifiedRecords: params }).then((res) => {
            if (res.data.status === 200) {
              this.$Message.success({
                content: `提交成功-不合格单号:${res.data.data}`,
                duration: 10,
                closable: true,
              });
              this.clear();
            } else {
              this.$Message.error(res.data.error);
            }
            this.submitLoading = false;
          }).catch((err) => {
            this.submitLoading = false;
            utils.handleError(err);
          });
        } else {
          this.$Message.error('请按照要求填写');
        }
      });
    },
    handleTempSelect(selection, row) {
      if (!this.selectedTempGoodsIds.includes(row.id)) {
        this.tempGoods.push(row);
      }
    },
    handleTempCancel(selection, row) {
      this.tempGoods.forEach((item, index) => {
        if (item.id === row.id) {
          this.tempGoods.splice(index, 1);
        }
      });
    },
    handleSelectAll(selection) {
      selection.forEach((item) => {
        if (!this.selectedTempGoodsIds.includes(item.id)) {
          this.tempGoods.push(item);
        }
      });
    },
    handleSelectAllCancel() {
      this.modalTableData.forEach((good) => {
        for (let i = 0, len = this.tempGoods.length; i < len; i++) {
          if (this.tempGoods[i].id === good.id) {
            this.tempGoods.splice(i, 1);
            break;
          }
        }
      });
    },
    clear() {
      this.$router.go(-1);
    },
    clearModalQuery() {
      this.modalQueryParams = {
        text: null,
        beforeExpireDays: null,
      };
    },
    clearModal() {
      this.hideModal();
      this.clearModalQuery();
      this.modalTableData = [];
    },
    hideModal() {
      this.showModal = false;
    },
    handleModalSearch() {
      this.modalSelection = [];
      this.goodsPage.page = 1;
      this.goodsPage.size = 10;
      this.modalParams = utils.deepClone(this.modalQueryParams);
      this.getInventoryData();
    },
    handleGoodsPage(val) {
      this.goodsPage.page = val;
      this.getInventoryData();
    },
    handleGoodsSize(val) {
      this.goodsPage.size = val;
      this.getInventoryData();
    },
  },
  created() {
    this.inventoryIds = this.$route.params.ids;
    if (this.inventoryIds) {
      this.getData();
    }
  },
};
</script>
<style lang="less" scoped>
</style>
